import { useState, useEffect } from 'react';

// Interface para las frases con sus citas
interface FraseInspiradora {
  frase: string;
  tipoReferencia?: string;
  cita?: string;
  categoria: string;
}

// Array de frases inspiradoras organizadas por categorías
const frasesPorCategoria: FraseInspiradora[] = [
  // REFERENCIAS BÍBLICAS
  {
    frase: "Dios prospera las manos que trabajan con fe.",
    tipoReferencia: "Inspirado en",
    cita: "Proverbios 12:11",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "Así como el pastor cuida su rebaño, el Señor cuida al que siembra con amor y constancia.",
    tipoReferencia: "Basado en",
    cita: "Salmo 23:1-3",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "Cada amanecer en el campo es una nueva promesa de Dios.",
    tipoReferencia: "Inspirado en",
    cita: "Lamentaciones 3:22-23",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "El emprendedor que confía en Dios no teme la sequía, porque su raíz está en aguas vivas.",
    tipoReferencia: "Basado en",
    cita: "Jeremías 17:7-8",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "Dios da fuerzas al cansado, y multiplica las fuerzas del que trabaja por un sueño con fe.",
    tipoReferencia: "Inspirado en",
    cita: "Isaías 40:29-31",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "Quien siembra con propósito y gratitud cosechará más que ganado: cosechará bendición.",
    tipoReferencia: "Basado en",
    cita: "2 Corintios 9:6-8",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "El Señor bendice los corrales limpios y las manos que no se rinden ante la jornada.",
    tipoReferencia: "Inspirado en",
    cita: "Proverbios 14:23",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "Dios ve el valor del hombre y la mujer del campo, porque en su esfuerzo hay fidelidad y esperanza.",
    tipoReferencia: "Basado en",
    cita: "Colosenses 3:23-24",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "El buen emprendedor no teme los días nublados, porque sabe que el sol de Dios siempre vuelve a brillar.",
    tipoReferencia: "Inspirado en",
    cita: "Salmo 30:5",
    categoria: "Referencias bíblicas"
  },
  {
    frase: "No hay trabajo pequeño cuando se hace para la gloria de Dios.",
    tipoReferencia: "Basado en",
    cita: "1 Corintios 10:31",
    categoria: "Referencias bíblicas"
  },

  // MOTIVACIÓN DIARIA
  {
    frase: "Cada amanecer es una nueva oportunidad para mejorar lo que ayer parecía imposible.",
    categoria: "Motivación diaria"
  },
  {
    frase: "No importa el tamaño del rebaño, sino la pasión con que lo cuidas.",
    categoria: "Motivación diaria"
  },
  {
    frase: "Los sueños florecen donde hay constancia, no donde hay prisa.",
    categoria: "Motivación diaria"
  },
  {
    frase: "La tierra recompensa al que trabaja con amor, no al que se queja del sol.",
    categoria: "Motivación diaria"
  },
  {
    frase: "Un día de esfuerzo vale más que mil de intención.",
    categoria: "Motivación diaria"
  },
  {
    frase: "Las metas grandes comienzan con pasos pequeños y firmes.",
    categoria: "Motivación diaria"
  },
  {
    frase: "No temas comenzar de nuevo; esta vez lo haces con más experiencia.",
    categoria: "Motivación diaria"
  },
  {
    frase: "El campo enseña que todo lo valioso requiere tiempo.",
    categoria: "Motivación diaria"
  },
  {
    frase: "Cada gota de sudor es una semilla de progreso.",
    categoria: "Motivación diaria"
  },
  {
    frase: "El éxito no llega por suerte, llega por perseverancia.",
    categoria: "Motivación diaria"
  },

  // PACIENTIA Y COSECHA
  {
    frase: "Cada semilla tiene su propio tiempo para despertar.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "La paciencia es el arte de confiar en que el suelo ya está trabajando por ti.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "Ningún fruto nace de prisa; todo lo bueno madura lento.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "La cosecha siempre llega a los que no abandonan el campo.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "El que siembra con fe no teme al silencio del tiempo.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "Esperar no es perder tiempo, es dejar que la tierra hable.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "El esfuerzo de hoy es la cosecha del mañana.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "Lo que florece tarde suele durar más.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "No corras detrás del fruto, cuida la raíz.",
    categoria: "Paciencia y cosecha"
  },
  {
    frase: "El campo premia a quien persevera sin mirar el reloj.",
    categoria: "Paciencia y cosecha"
  },

  // FORTALEZA Y PERSEVERANCIA
  {
    frase: "El cansancio no derrota al que tiene propósito.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "La fuerza del alma vale más que la del cuerpo.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "No hay jornada dura para quien trabaja con corazón firme.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "El que sigue adelante, aunque tiemble, ya es fuerte.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "Perseverar es creer que el esfuerzo tiene sentido.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "La fortaleza no está en no caer, sino en levantarse siempre.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "Las manos cansadas también son señales de bendición.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "La lluvia no detiene al que sabe hacia dónde va.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "La perseverancia hace posible lo que parecía imposible.",
    categoria: "Fortaleza y perseverancia"
  },
  {
    frase: "Cada amanecer es una nueva oportunidad para resistir.",
    categoria: "Fortaleza y perseverancia"
  },

  // GRATITUD Y BENDICIÓN
  {
    frase: "Agradecer cada amanecer es la mejor forma de empezar el día.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "Quien ve la bendición en lo pequeño, siempre vive en abundancia.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "Cada día que despiertas es un regalo, no una costumbre.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "La gratitud convierte el trabajo en alegría.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "Agradecer abre puertas que el esfuerzo solo no puede abrir.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "Bendecido no es quien tiene mucho, sino quien aprecia todo.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "Cada respiro es una señal de que aún hay propósito.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "La gratitud transforma el cansancio en paz.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "No hay día sin bendición para quien sabe mirar.",
    categoria: "Gratitud y bendición"
  },
  {
    frase: "El que agradece, multiplica lo que tiene.",
    categoria: "Gratitud y bendición"
  },

  // SABIDURÍA Y ADMINISTRACIÓN
  {
    frase: "La fuerza no proviene de lo que puedes hacer, sino de superar lo que creías imposible.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "Perseverar cuando todo parece perdido es lo que te hace invencible.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "La fortaleza se forja en los días difíciles, no en los fáciles.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "Quien sigue intentando nunca fracasa del todo.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "La vida premia a quienes no se rinden.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "Cada caída es una lección, no un final.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "Los fuertes también lloran, pero nunca se detienen.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "Perseverar es creer que el esfuerzo de hoy será el fruto de mañana.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "La fortaleza es mantener la calma cuando el alma tiembla.",
    categoria: "Sabiduría y administración"
  },
  {
    frase: "Si no puedes volar, corre; si no puedes correr, camina; pero nunca te detengas.",
    categoria: "Sabiduría y administración"
  },

  // ENFOQUE Y DISCIPLINA
  {
    frase: "La disciplina vence al talento cuando el talento no se disciplina.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "Donde pones tu enfoque, pones tu poder.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "No necesitas motivación, necesitas constancia.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "El enfoque convierte la energía en resultados.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "La disciplina es hacer lo que debes, incluso cuando no tienes ganas.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "Enfocarte no es hacer más, es hacer lo que importa.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "La constancia supera a la inspiración.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "Sin disciplina, los sueños se quedan en deseos.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "El enfoque es el arte de decir 'no' a lo que no te acerca a tu meta.",
    categoria: "Enfoque y disciplina"
  },
  {
    frase: "La clave del éxito es la rutina bien dirigida.",
    categoria: "Enfoque y disciplina"
  }
];

// Función para mapear preferencias de la BD a categorías de frases
const mapearPreferenciasACategoria = (messagesPref: string): string => {
  const mapeo: { [key: string]: string } = {
    'fe': 'Referencias bíblicas',
    'negocios': 'Sabiduría y administración', 
    'motivacional': 'Motivación diaria',
    'paciencia': 'Paciencia y cosecha',
    'fortaleza': 'Fortaleza y perseverancia',
    'gratitud': 'Gratitud y bendición',
    'disciplina': 'Enfoque y disciplina'
  };
  
  return mapeo[messagesPref] || 'Referencias bíblicas';
};

export const useRandomFrase = (categoriaSeleccionada?: string, messagesPref?: string) => {
  const [fraseActual, setFraseActual] = useState<FraseInspiradora | null>(null);

  useEffect(() => {
    let categoriaFinal: string;

    if (categoriaSeleccionada) {
      // Si se especifica una categoría directamente, usarla
      categoriaFinal = categoriaSeleccionada;
    } else if (messagesPref) {
      // Si se tiene preferencia de la BD, mapearla a categoría
      categoriaFinal = mapearPreferenciasACategoria(messagesPref);
    } else {
      // Fallback: usar localStorage o por defecto
      const categoriaGuardada = localStorage.getItem('categoriaMensaje') || 'Referencias bíblicas';
      categoriaFinal = categoriaGuardada;
    }

    // Filtrar frases por la categoría seleccionada
    const frasesFiltradas = frasesPorCategoria.filter(frase => frase.categoria === categoriaFinal);
    
    if (frasesFiltradas.length > 0) {
      // Seleccionar una frase aleatoria de la categoría
      const indiceAleatorio = Math.floor(Math.random() * frasesFiltradas.length);
      setFraseActual(frasesFiltradas[indiceAleatorio]);
    } else {
      // Fallback a referencias bíblicas si no se encuentra la categoría
      const frasesBiblicas = frasesPorCategoria.filter(frase => frase.categoria === 'Referencias bíblicas');
      const indiceAleatorio = Math.floor(Math.random() * frasesBiblicas.length);
      setFraseActual(frasesBiblicas[indiceAleatorio]);
    }
  }, [categoriaSeleccionada, messagesPref]);

  return fraseActual;
};